import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      maxHeight: theme.spacing(40),
      overflow: 'auto',
      gap: theme.spacing(1),
      margin: theme.spacing(3, 0, -4, 0),
      paddingRight: theme.spacing(2),
      '&::-webkit-scrollbar-track': {
        borderRadius: theme.spacing(2.25),
        backgroundColor: theme.palette.bgPrimary.main,
      },
      '&::-webkit-scrollbar': {
        width: theme.spacing(1),
        height: theme.spacing(1),
        backgroundColor: theme.palette.bgPrimary.main,
      },
      '&::-webkit-scrollbar-thumb': {
        width: theme.spacing(1),
        borderRadius: theme.spacing(2.25),
        backgroundColor: theme.palette.bgSecondary.main,
      },
    },
    offerExpiration: {
      color: theme.palette.text.expiredText,
      fontWeight: 400,
      fontFamily: theme.typography.fontFamily,
      fontSize: '12px',
      lineHeight: theme.spacing(2),
    },
    expiredOffer: {
      color: theme.palette.error.dark,
    },
    tooltipWrapper: {
      height: theme.spacing(3),
    },
    avatar: {
      '&.MuiAvatar-root': {
        display: 'flex',
        width: theme.spacing(3),
        height: theme.spacing(3),
        justifyContent: 'center',
        alignItems: 'center',
        gap: theme.spacing(1.25),
        textAlign: 'center',
        fontSize: '12px',
        fontStyle: 'normal',
        fontWeight: 600,
        letterSpacing: '0.5px',
        border: '1px solid transparent',
        color: theme.palette.labraText.tertiary,
        borderRadius: theme.spacing(6.5),
        background: `linear-gradient(0deg, ${theme.palette.avatarColors.blue} 0%, ${theme.palette.avatarColors.blue} 100%)`,
      },
    },
    description: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center',
    },
    tcvText: {
      color: theme.palette.labraText.description,
      fontWeight: 400,
      fontFamily: 'Poppins',
      fontSize: '12px',
      lineHeight: theme.spacing(2),
    },
    lastRow: {
      marginBottom: theme.spacing(4),
    },
  }
})
